export default {
	data() {
		return {
			params: {
				account_token: '',
				source: 'LuckyPlata',
			},
			apiHead: '',
			apiHeadGatewayVh: '',
			apiHeadGateway: '',
			url: '',
		}
	},
	mounted() {
		this.csstorem()
	},
	methods: {
		getAccessToken() {
			if (window.android && window.android.getAccessToken()) {
				this.params.account_token = window.android.getAccessToken()
			} else {
				this.params.account_token = '708cc40e5b9a2f3fc186591af2132ab9' //dfddde88b7255d0462d9b77688a3d394
			}
		},
		csstorem() {
			window.onload = function() {
				getRem(720, 100)
			}
			window.onresize = function() {
				getRem(720, 100)
			}
			function getRem(pwidth, prem) {
				var html = document.getElementsByTagName('html')[0]
				var oWidth = document.body.clientWidth || document.documentElement.clientWidth
				html.style.fontSize = (oWidth / pwidth) * prem + 'px'
			}
		},
		getApiHead() {
			if (location.href.indexOf('//www.luckyplata.co') >= 0) {
				this.apiHead = 'https://api.luckyplata.co/' //prod
				this.apiHeadGatewayVh = 'https://api.luckyplata.co/gateway/ApiService/api/v8/h5/' //prod
				this.apiHeadGateway = 'https://api.luckyplata.co/gateway/ApiService/'

				this.url = 'https://www.luckyplata.co'
			} else {
				this.apiHead = 'https://api-test-co.jinglewill.com/' //test
				this.apiHeadGatewayVh = 'https://api-test-co.jinglewill.com/gateway/ApiService/api/v8/h5/' //test
				this.FapiHeadGateway = 'https://api-test-co.jinglewill.com/gateway/ApiService/'

				this.url = 'http://luckyplata.jinglewill.com/278343382'

				const VConsole = require('vconsole')
				new VConsole()
			}
		},
		//Determine whether the information has been read  // type == true : if status == 8 go firstLoan page
		getLoanInfo(hsm, type) {
			this.$axios
				.post(this.apiHeadGatewayVh + 'orders/loan/info', {
					...this.params,
				})
				.then((res) => {
					if (res.data.code == 0) {
						this.loan_info = res.data.data.loan_info
						console.log(new Date(this.loan_info.surplus_hours))
						if (hsm && this.loan_info.surplus_hours) {
							this.countTime(this.loan_info.surplus_hours)
						}
						console.log('getLoanInfo-------h----------', type)
						if (type && this.loan_info.order_status == 8) {
							console.log('window.android.payFinish----------', window.android)
							window.android?.payFinish()
						}
					}
				})
		},
		//Get a coupon list
		getCoupon(value) {
			this.$axios
				.post(this.apiHeadGatewayVh + 'account/coupon/list', {
					list_type: 1,
					offset: 1,
					index_frame: 2,
					...value,
					...this.params,
				})
				.then((res) => {
					if (res.data.code == 0) {
						this.couponData = res.data.data
					}
				})
		},

		//get banner
		getGetBanner(value) {
			this.$axios
				.post(this.apiHeadGatewayVh + 'banner/get', {
					...value,
					app_version: JSON.parse(window.android?.getBaseInfo()).app_version,
					channel: JSON.parse(window.android?.getBaseInfo()).media_source,
					...this.params,
				})
				.then((res) => {
					if (res.data.code == 0) {
						this.bannerList = res.data.data.banners
					}
				})
		},
	},
}
